// Copyright (c) 2025 WSO2 LLC. (https://www.wso2.com).
//
// WSO2 LLC. licenses this file to you under the Apache License,
// Version 2.0 (the "License"); you may not use this file except
// in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { RootState, useAppSelector } from "@root/src/slices/store";
import { getActiveRoutesV2, routes } from "@root/src/route";
import PreLoader from "@root/src/component/common/PreLoader";

const Link = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(function Link(
  itemProps,
  ref
) {
  return <RouterLink ref={ref} {...itemProps} role={undefined} />;
});

export default function Error() {
  const auth = useAppSelector((state: RootState) => state.auth);
  const userRoutes = getActiveRoutesV2(routes, auth.roles);
  const routesReady = userRoutes && userRoutes.length > 0;

  if (auth.status === "loading" || !routesReady)
    return <PreLoader message={null} />;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h1" style={{ color: "gray" }}>
        404
      </Typography>
      <Typography variant="h6" style={{ color: "gray" }}>
        The page you're looking for doesn't exist..
      </Typography>
      <Button component={Link} to={"/"} variant="contained">
        Back Home
      </Button>
    </Box>
  );
}
